import React, { Component } from 'react';
import autoBind from "react-autobind";

import { TestResult } from './TestResult';

export class TestResultContainer extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const { redirectUrl, outcome, loading, requirements, exclusions } = props.location.state;
    this.state = {
      redirectUrl,
      outcome, 
      loading,
      requirements,
      exclusions
    }
  }

  render() {
    const { redirectUrl, outcome, loading, requirements, exclusions } = this.state;
    return (
      <div>
        <TestResult 
          loading={loading} 
          outcome={outcome} 
          requirements={requirements}
          exclusions={exclusions}
          redirectUrl={redirectUrl} />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/testResult/TestResultContainer.js